// Entry animation for view/route switches (design system motion: restrained,
// standard MUI easing, ~225ms). Replay it by remounting the element (key prop).
export const viewEnterSx = {
    animation: 'viewEnter 225ms cubic-bezier(0.4, 0, 0.2, 1)',
    '@keyframes viewEnter': {
        from: { opacity: 0 },
        to: { opacity: 1 },
    },
    '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
}
